import { useDisablePageScroll } from '@cian/ui-kit/internal/hooks/useDisablePageScroll';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

import styles from './AuthenticationModalMobileContainer.css';

interface IAuthenticationModalMobileContainerProps {
  children: React.ReactNode;
  open: boolean;
  onClose(): void;
  outside: boolean;
}

/**
 * Временное решение, пока я ui-kit не обновятся анимации шторок
 * Тред с обсуждение в slack - https://cianplc.slack.com/archives/C04CKNTR6JH/p1756798612827569
 */
export const AuthenticationModalMobileContainer: React.FunctionComponent<IAuthenticationModalMobileContainerProps> =
  React.memo(({ open, onClose, children }: IAuthenticationModalMobileContainerProps) => {
    const host = typeof document !== 'undefined' ? document.body : null;
    useDisablePageScroll(open);

    if (!host || !open) {
      return null;
    }

    const component = (
      <div className={styles['overlay']}>
        <div className={styles['content']}>
          <div className={styles['head']}>
            <div className={styles['close']} onClick={onClose} role="button" aria-label="Закрыть">
              <IconActionClose16 color="current_color" />
            </div>{' '}
          </div>
          <div className={styles['body']}>{children}</div>
        </div>
      </div>
    );

    return ReactDOM.createPortal(component, host);
  });

AuthenticationModalMobileContainer.displayName = 'AuthenticationModalMobileContainer';
